<template>
  <div>
      <mt-cell title="客戶問卷調查" style="text-align: center"></mt-cell>
      <mt-field label="客戶姓名：" placeholder="" v-model="customerName">(可以匿名)</mt-field>
      <mt-field label="投保日期：" type="date" placeholder="" v-model="insuranceDate"></mt-field>
      <mt-field label="業務人員：" placeholder="" v-model="businessName"></mt-field>

      <mt-cell title="請在下列評分方格內打√(10分最高分)" style="text-align: center"></mt-cell>
      <hr>
      <div v-for="projectContent in projectContentList" >
          <mt-cell    :title="projectContent.projectContent" style="color:red" ></mt-cell>
              <div >
                  <span style="margin-left: 10px;float: left;font-size: 16px;margin-top: 7px;">請選擇分數：</span>
                  <mt-picker style="width: 60%;float: left"  :slots="slots"   :visibleItemCount="visibleItemCountTwo" @change="onValuesChange" :value-key="'project-'+projectContent.id"></mt-picker>
                  <br/>
                  <mt-field style="width: 100%;"  label="改善地方" placeholder="：有待改進的地方及原因" type="textarea" rows="3" :id="projectContent.id" @blur.native.capture="addReason"></mt-field>
                  <hr>
              </div>
      </div>
      <mt-field label="等侯簽單員的所需時間:"  type="number" style=""  placeholder="" v-model="waitingTime" @blur.native.capture="getFocusTwo">分鐘(預約時間起計算)</mt-field>
      <hr/>
      <mt-field   label="其他意見：" placeholder="" type="textarea" rows="3" v-model="otherOpinions" @blur.native.capture="getFocusTwo" ></mt-field>
      <mt-button type="primary" size="large" @click="addQuestionnaire">提交</mt-button>

  </div>
</template>



<script>
    import "mint-ui/lib/style.css";
    import { MessageBox  } from 'mint-ui';
    import {queryProjectContentAll,insertQuestionnaire} from '../api/api'
    import $ from 'jquery'
    import Utils from './js/utils.js'

    export default {
        name: "Questionnaire",
        data(){
            return {
                isRouterAlive:true,
                projectContentList:[],
                businessName:'',
                rangeValue:1,
                visibleItemCountTwo:1,
                slots:[
                    {
                        flex: 1,
                        values: ['1', '2', '3', '4', '5', '6', '7', '8', '9', '10'],
                        className: 'slot1',
                        textAlign: 'left',
                        defaultIndex:9
                    }
                ],
                questionnaireList:[],
                questionnaireIs:true,
                otherOpinions:'',
                waitingTime:0,
                customerName:'',
                insuranceDate:''
            }
        },
        methods:{
            getFocusTwo(){
                window.scroll(0, window.document.body.scrollHeight);
            },
            addQuestionnaire(){
                if(this.customerName == "" || this.customerName == undefined ||this.customerName.length < 1){
                    MessageBox('提示', '請填寫客戶姓名');
                    return;
                }
                if(this.insuranceDate == "" || this.insuranceDate == undefined || this.insuranceDate < 1){
                    MessageBox('提示', '請選擇投保日期');
                    return;
                }
                if(this.businessName == "" || this.businessName == undefined || this.businessName < 1){
                    MessageBox('提示', '請填寫業務人員名稱');
                    return;
                }

                let params = {businessName:this.businessName,insuranceDate:this.insuranceDate,customerName:this.customerName,
                    questionnaireList:JSON.stringify(this.questionnaireList),waitingTime: this.waitingTime,otherOpinions:this.otherOpinions,
                    staffId:Utils.decrypt(this.$route.query.staffId,'hAw6eqnFLKxpsDv4')}
                return insertQuestionnaire(params).then(res=>{
                    if(res.errcode==200){
                        MessageBox.alert('提交成功').then(action => {
                            if (action === 'confirm') {
                                var sTop = document.body || document.documentElement;
                                sTop.scrollTop = 0;
                                location.reload();
                            }
                        });
                    }else{
                        this.$message.error(res.errmsg);
                    }

                }).catch((error)=>{
                    console.log("queryOptionMyPolicy Error");
                });

            },
            onValuesChange(picker,values){
                // console.log(values[0]);
                // console.log(document.getElementById(picker.valueKey))
                // console.log(picker.valueKey);

                if(picker.valueKey == null){
                    return;
                }
                let id = picker.valueKey.substr(8,picker.valueKey.length);
                if(this.questionnaireList.length<1){
                    let questionnaires = {projectContentId:id,fraction:10,reasonImprovement:''};
                    this.questionnaireList.push(questionnaires);
                }else{
                    this.questionnaireIs =this.questionnaireList.some(item=>{
                       if(item.projectContentId == id){
                           if(values!=undefined){
                               item.fraction = values[0];
                           }else{
                               item.fraction = 10;
                           }
                           return true;
                       }else{
                           return false;
                       }
                    });
                    if(this.questionnaireIs){

                    }else{
                        if(values!=undefined){
                            let questionnaires = {projectContentId:id,fraction:values[0],reasonImprovement:''};
                            this.questionnaireList.push(questionnaires);
                        }else{
                            let questionnaires = {projectContentId:id,fraction:10,reasonImprovement:''};
                            this.questionnaireList.push(questionnaires);
                        }
                    }
                }

            },
            addReason(el){
                let projectId = el.srcElement.parentNode.parentNode.parentNode.id;
                let content = el.srcElement.value;

                if(this.projectContentList.length-projectId <2){
                    window.scroll(0, window.document.body.scrollHeight);
                }

                if(this.questionnaireList.length > 0 && projectId.length != undefined){
                    this.questionnaireIs =this.questionnaireList.some(item=>{
                        if(item.projectContentId == projectId){
                            if(content!=undefined){
                                item.reasonImprovement = content;
                            }else{
                                item.reasonImprovement = '';
                            }
                            return true;
                        }else{
                            return false;
                        }
                    });

                }
            },
            queryProjectContentAll(){
                let params = {};
                return queryProjectContentAll(params).then(res=>{
                    if(res.errcode==200){
                        this.projectContentList=res.data;
                    }else{
                        this.$message.error(res.errmsg);
                    }
                }).catch((error)=>{
                    console.log("queryOptionMyPolicy Error");
                });
            }
        },
        mounted() {
            this.queryProjectContentAll();
        },
    }
</script>

<style scoped>

    body {
        font-family: sans-serif;
    }

</style>


// WEBPACK FOOTER //
// src/views/Questionnaire.vue